import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal, Skeleton } from '../../../../components';
import MyActivityCard from './MyActivityCard';
import PaginationMyActivity from './PaginationMyActivity';

import { myActivityArray } from '../../../../util/types';

import css from './MyActivityModal.module.css';


const MyActivityModal = props => {
  const {
    onSetActiveTab,
    isMyActivity,
    onManageDisableScrolling,
    onFetchUserActivity,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    routeConfiguration,
    history,
    currentCommunityMember
  } = props;

  const [isActiveTab, setIsActiveTab] = useState("posts");

  const {
    roles,
    id: community_member_id,
    posts_count,
    comments_count
  } = currentCommunityMember || {};
  const {
    page,
    per_page,
    has_next_page,
    count,
    sort,
    records
  } = fetchUserActivityData || {};

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    onFetchUserActivity({
      community_member_id: currentCommunityMember?.id,
      fetchTab: isActiveTab,
      page: newPage,
      per_page: itemsPerPage,
    });
  };
  return (
    <>
     {isMyActivity ?  <Modal
        id="myActivityModal"
        isOpen={!!isMyActivity}
        onClose={() => {
          setCurrentPage(1);
          setIsActiveTab("posts")
          onSetActiveTab()
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.reportContentModal}
      >
        <div>
          <div className={css.tabsContainer}>
            {myActivityArray.map((item) => (
              <div
                key={item.tab}
                className={`${css.feedContainer} ${isActiveTab === item.tab ? css.activeTab : ''} ${fetchUserActivityRequest ? css.disabledTab : ''}`}
                onClick={() => {
                  if (isActiveTab !== item.tab) {
                    setIsActiveTab(item.tab);
                    setCurrentPage(1);
                    onFetchUserActivity({
                      community_member_id,
                      fetchTab: item.tab,
                      page: 1,
                      per_page: per_page
                    });
                  }
                }}
              >
                <span className={css.icon}>{item.Icon}</span>
                <span>{item.text} {item.text == "Posts" ? posts_count : comments_count}</span>
              </div>
            ))}
          </div>
          <div>
            {fetchUserActivityRequest ? (
               <Skeleton type={true} />
            ) : (
              <div>
                {Array.isArray(records) && records.length > 0 ? records.map((record) => (
                  <MyActivityCard
                    key={record.id}
                    activityRecord={record}
                    setIsActivityRequested={() => {
                      setCurrentPage(1);
                      setIsActiveTab("posts")
                      onSetActiveTab();
                    }}
                    history={history}
                    routeConfiguration={routeConfiguration}
                    isActiveTab={isActiveTab}
                  />
                )) : <div>
                 <FormattedMessage id="MyActivityModal.noRecordsFound" values={{type:isActiveTab}} />
                 </div>
                }
                {count ? <div className={css.paginationControls}>
                  <PaginationMyActivity
                    currentPage={currentPage}
                    hasNextPage={has_next_page}
                    onPageChange={handlePageChange}
                    posts_count={posts_count}
                    per_page={per_page}
                    comments_count={comments_count}
                    isActiveTab={isActiveTab}
                  />
                </div> : null}
              </div>
            )
            }
          </div>

        </div>
      </Modal>: null}
    </>
  );
};

export default MyActivityModal;
